module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/fallback_red-7ec0c35a75751815d9cbbbf710c25b02.svg";